<template>
    <div class="wrapper">
        <div class="audio-box" @click="playAudio($event, idx, ban)">
            <AudioPlayer :audio-list="audioList" :show-play-button="true" :show-prev-button="false" :show-next-button="false" :show-progress-bar="false" :isLoop="false" />
        </div>
        <!-- 字幕部分 -->
        <div class="lyricWrapper" v-show="switchBannerHide">
            <div class="lyricContainer" :id="idName ? idName : 'lyric-' + idx">
                <p v-for="item in lyricText" :key="item.time">{{ item.words }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { AudioPlayer } from '@liripeng/vue-audio-player';
import '@liripeng/vue-audio-player/lib/vue-audio-player.css';

export default {
    components: {
        AudioPlayer,
    },
    props: ['anchorIndex', 'audioCont', 'ban2Class', 'lyric', 'id', 'switchBanner'],
    data() {
        return {
            idx: this.anchorIndex,
            audioList: Array.of(this.audioCont),
            ban: this.ban2Class,
            idName: this.id,
            switchBannerHide: this.switchBanner,
            lyricText: this.lyric,
            Subtitle: null,
        };
    },
 
    methods: {
        pauseVideoPlayer() {
            let videos = document.getElementsByTagName('video');
            // 音频播放时停止其他的视频播放
            [].forEach.call(videos, function(i, index) {
                i.pause();
            });
        },
        playAudio(e, idx, bans) {  
            // 音频播放时停止其他的视频播放以及背景音乐播放
            this.pauseVideoPlayer();
            let lyricWrapperDom = e.currentTarget.nextElementSibling;               
            this.Subtitle = this.idName ? document.getElementById(this.idName) : document.getElementById(`lyric-${this.idx}`);
            let that = this;
            // 所有的麦克风置为斜杠状态
            this.$emit('banHandler', idx, bans);
            // 切换当前点击的麦克风置状态
            setTimeout(function() {
                that.$emit('changeMicrophone', idx, bans);
            }, 100);
            // 获取所有audios
            let audios = document.getElementsByTagName('audio');
            let currentAudio = e.currentTarget.getElementsByTagName('audio');
            // 暂停函数
            function pauseAll() {
                let self = this;
                [].forEach.call(audios, function(i, curIndex) {
                    // 将audios中其他的audio全部暂停
                    if (i != self) {
                        i.pause();
                    } else {
                        i.play();
                    }
                });
            }
            // 给play事件绑定暂停函数
            [].forEach.call(audios, function(i, curIndex) {
                i.addEventListener('play', pauseAll.bind(i));
            });
            // 监听到语音播放完毕后恢复斜杠状态
            currentAudio[0].addEventListener(
                'ended',
                function() {
                    that.$emit('resetMicrophone', idx);
                    that.$emit('playBackgroundMusic');
                    // 隐藏字幕区域
                    that.switchBannerHide = false;
                },
                false
            );
            // 语音同步字幕
            currentAudio[0].addEventListener('timeupdate', function() {
                // 将上次播放的高度清0
                that.Subtitle.style.top = 0;
                // 显示字幕区域
                that.switchBannerHide = true;
                
                let _this = this;
                if (!that.lyric) return;
                for (let i = 0; i < that.lyric.length; i++) {
                    //比对时间
                    if (this.currentTime > that.lyric[i].time - 0.5) {
                        // 获取每个字幕的高度
                        let h = lyricWrapperDom.clientHeight;console.log(h) 
                        // 设置字幕区域的top
                        that.Subtitle.style.top = -(h * i) + 'px';
                    }
                }
            });
        },
    },
};
</script>
<style>

.audio-box {
    position: absolute;
    left: 0rem;
    bottom: 0rem;
    z-index: 111;
    width: 0.3rem;
    height: 0.3rem;
}
.audio-box .audio-player .audio__btn-wrap .audio__play__icon {
    color: transparent;
}
.audio-box .audio-player .audio__btn-wrap .audio__play--pause,
.audio-box .audio-player .audio__btn-wrap .audio__play--start {
    width: 0.3rem;
    height: 0.3rem;
    position: absolute;
    left: 0rem;
    bottom: 0;
}
.lyricWrapper {
    position: absolute;
    left: 550%;
    top: 0;
    width: 1500%;
    height: 0.25rem;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 2em;
    line-height: 0.25rem;
}
.lyricContainer {
    position: relative;
}
.lyricContainer p {
    color: #fff;
    transform: scale(0.9);
    text-align: center;
    font-size: 20px;
}
</style>
